import { createAction } from '@src/redux/helpers/createAction';
import {
  SET_STEPPER,
  SET_STEP,
  SET_CURRENT_STEP,
  SET_COMPLETE_STEP,
  RESET_STEP,
} from './constants';

export const setStepper = (payload) => {
  return createAction({
    type: SET_STEPPER,
    payload,
    cache: true,
  });
};
export const setStep = (payload) => {
  return createAction({
    type: SET_STEP,
    payload,
  });
};
export const setCurrentStep = (payload) => {
  return createAction({
    type: SET_CURRENT_STEP,
    payload,
    cache: true,
  });
};
export const setCompleteStep = (payload) => {
  return createAction({
    type: SET_COMPLETE_STEP,
    payload,
  });
};
export const resetStep = (payload) => {
  return createAction({
    type: RESET_STEP,
    payload,
  });
};
